import { DownloadSimpleIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CloudDownload = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <DownloadSimpleIcon {...rest} width={Sizes[size]} height={Sizes[size]} color={fill} />;
};

CloudDownload.displayName = 'CloudDownload';
